//
//
//
//
import articleBase from '../articleBase';
export default {
  name: 'anLi',
  components: {
    articleBase: articleBase
  }
};